var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFffFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.676,
    y1: 19.9,
    x2: 132.5773,
    y2: 19.9,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C47DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDBCD4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,14.1c0-0.6,0.4-0.8,0.9-0.8c0.6,0,1.3,0,1.9,0c0.2,0,0.4,0,0.6,0c0.2-1.3,0.3-2.6,0.5-3.9 c-0.2,0-0.4-0.1-0.6-0.1c-0.9-0.1-1.9-0.1-2.8-0.1c-0.9,0-1.8,0-2.7,0.1c-1,0.1-1.7,0.6-2.2,1.4c-0.4,0.6-0.6,1.3-0.6,2 c0,1.1,0,2.2,0,3.2c0,0.1,0,0.2-0.2,0.1c-0.7,0-1.4,0-2,0H14c0,1.3,0,2.6,0.1,4c0.8,0,1.5,0,2.3,0c0,3.7,0,7.4,0,11c1.7,0,3.4,0,5,0 c0-3.7,0-7.4,0-11c1.2,0,2.3,0,3.5,0c0-1.4,0-2.7,0-4.1c-1.2,0-2.3,0-3.5,0C21.3,15.4,21.3,14.8,21.3,14.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFffFacebook);
export default __webpack_public_path__ + "static/media/fff-facebook.55adef89be39b34a5d7703cdb5d7219c.svg";
export { ForwardRef as ReactComponent };